import React from "react";
import { ClockCircleOutlined } from "@payping/icons";
import { InvoiceStatusEnum } from "@payping/api";
import { toJalali } from "@payping/utils/dateUtils";
import { Collapse } from "@payping/web-components";

import { useAppTranslation } from "@/utils/useAppTranslation";
import Flex from "../../../../components/DashInvoice/Flex";

interface Props {
  sendDate?: string;
  dueDate?: string;
  payedDateTime?: string;
  status?: InvoiceStatusEnum;
}

const DetailDate: React.FC<Props> = (props: Props) => {
  const { dueDate, sendDate, payedDateTime, status } = props;
  const { t } = useAppTranslation();

  return (
    <Collapse>
      <Collapse.Panel key={0} header={"تاریخ"}>
        <Flex className="tw-mb-5 tw-w-full" justifyContent="space-between">
          <span style={{ color: "#0080FF" }}>{t("send")}</span>
          <div>
            {/* <span className={"color--gray500 tw-ml-4"}>
              {toJalali({ date: sendDate, toFormat: "HH:mm" }).string}
              <ClockCircleOutlined width={12} className={"color--gray500 tw-mr-[5px] tw-mt-1"} />
            </span> */}
            <span>{toJalali({ date: sendDate, toFormat: "jYYYY/jMM/jDD" }).string}</span>
          </div>
        </Flex>
        <Flex className="tw-mb-5 tw-w-full" justifyContent="space-between">
          <span>{t("dueDate")}</span>
          <div>
            {/* <span className={"color--gray500 tw-ml-4"}>
              {toJalali({ date: dueDate, toFormat: "HH:mm" }).string}
              <ClockCircleOutlined width={12} className={"color--gray500 tw-mr-[5px] tw-mt-1"} />
            </span> */}
            <span>{toJalali({ date: dueDate, toFormat: "jYYYY/jMM/jDD" }).string}</span>
          </div>
        </Flex>
        {status === InvoiceStatusEnum.PAID ? (
          <Flex className="tw-w-full" justifyContent="space-between">
            <span style={{ color: "#52C41A" }}>{t("payment")}</span>
            <div>
              <span className={"color--gray500 tw-ml-4"}>
                {toJalali({ date: payedDateTime, toFormat: "HH:mm" }).string}
                <ClockCircleOutlined width={12} className={"color--gray500 tw-mr-[5px] tw-mt-1"} />
              </span>
              <span>{toJalali({ date: payedDateTime, toFormat: "jYYYY/jMM/jDD" }).string}</span>
            </div>
          </Flex>
        ) : null}
      </Collapse.Panel>
    </Collapse>
  );
};

export default DetailDate;
